import { Button } from 'antd';
/**
 * @component AddButton.tsx
 * @description AddButton component to add users.
 * @return { component }
 */
interface AddButtonProps {
  showModal: (show: boolean) => void;
  title: string;
  icon: React.ReactNode;
}
function AddButton(props: AddButtonProps) {
  const showModal = () => {
    props.showModal(true);
  };
  return (
    <Button
      className="at-add-button"
      type="primary"
      shape="round"
      icon={props.icon}
      onClick={showModal}
      size={'large'}
    >
      {props.title}
    </Button>
  );
}

export default AddButton;
